const el = document.querySelector('.js-RangeInput')
const input = el.querySelector('input[type=range]')
const target = el.querySelector('.form__row-range-value span')


input.addEventListener("input", (event) => {
  let formattedNumber = new Intl.NumberFormat('cs-CZ').format(event.target.value);

  target.textContent = formattedNumber;
});
